import { apiService } from '@/shared/services/api/api.service';

export type VideoType = 'TRAINING' | 'COMPLIANCE' | 'GENERAL';

export interface TrainingVideo {
  id: string;
  title: string;
  description?: string | null;
  type: VideoType;
  videoUrl: string;
  thumbnailUrl?: string | null;
  duration: number;
  displayOrder: number;
  isRequired: boolean;
  campaignId?: string | null;
  isActive: boolean;
  allowSkipping: boolean;
  minWatchPercentage: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface VideoProgress {
  id: string;
  userId: string;
  videoId: string;
  watchedSeconds: number;
  lastWatchedAt: Date;
  completed: boolean;
  completedAt?: Date | null;
  watchSessions?: any;
  createdAt: Date;
  updatedAt: Date;
  video?: TrainingVideo;
}

export interface VideoWithProgress extends TrainingVideo {
  progress?: VideoProgress | null;
  watchPercentage?: number;
}

export interface VideosCompletionStatus {
  videos: VideoWithProgress[];
  totalVideos: number;
  totalRequired: number;
  completedVideos: number;
  completedRequired: number;
  allRequiredComplete: boolean;
  overallProgress: number;
}

class TrainingVideoService {
  /**
   * Get all videos for current user with progress
   */
  async getMyVideos(): Promise<{ success: boolean; data: VideosCompletionStatus }> {
    const response = await apiService.get<{ success: boolean; data: VideosCompletionStatus }>(
      '/training-videos/my-videos'
    );
    return response.data;
  }

  /**
   * Update video watch progress
   */
  async updateProgress(
    videoId: string,
    watchedSeconds: number,
    completed?: boolean
  ): Promise<{ success: boolean; data: VideoProgress }> {
    const response = await apiService.post<{ success: boolean; data: VideoProgress }>(
      `/training-videos/${videoId}/progress`,
      { watchedSeconds, completed }
    );
    return response.data;
  }
}

export const trainingVideoService = new TrainingVideoService();
